export const agentConfig = {
    // 1. AI应用名称
    appName: "AI短视频助手",
    
    // 2. 系统设置界面的BASE URL地址（调用API的地址）
    baseUrl: "https://www.xnora.fun/",
    
    // 3. 价格系数，本应用价格是按系数0.7设置的
    priceCoefficient: 0.7,
    
    // 4. 微信客服 (微信号)
    wechatCustomerService: "syz40446542",
    
    // 5. 令牌分设置教程连接
    tutorialLink: "https://my.feishu.cn/wiki/EPP6wHZEVi1Wi4kZac5cGWDTnx3",
    
    // 6. 招募优质API代理下面的查看更多详情的跳转链接
    agentRecruitmentLink: "https://my.feishu.cn/wiki/O6Q9wrxxci898Wkj6ndcFnlknJd",
};
